export function partitionByIntersection(groups: SVGGElement[]) {
  const noCollisions: SVGGElement[] = []
  const withCollisions: SVGGElement[] = []

  for (const group of groups) {
    const hasCollision = noCollisions.some(otherGroup => groupsIntersect(group, otherGroup))

    if (hasCollision) {
      withCollisions.push(group)
    } else {
      noCollisions.push(group)
    }
  }

  return { noCollisions, withCollisions }
}

function groupsIntersect(groupA: SVGGElement, groupB: SVGGElement): boolean {
  // Get pin images (aria-label="pin") from both groups
  const pinA = groupA.querySelector('image[aria-label="catmarker-pin"]') as unknown as SVGGElement | null
  const pinB = groupB.querySelector('image[aria-label="catmarker-pin"]') as unknown as SVGGElement | null

  // Get text elements (aria-label="caption") from both groups
  const textA = groupA.querySelector('text[aria-label="catmarker-caption"]') as unknown as SVGGElement | null
  const textB = groupB.querySelector('text[aria-label="catmarker-caption"]') as unknown as SVGGElement | null

  // Check if any combination of elements intersect
  const intersections = [
    pinA && pinB && boxesIntersect(pinA.getBBox(), pinB.getBBox()),
    pinA && textB && boxesIntersect(pinA.getBBox(), textB.getBBox()),
    textA && pinB && boxesIntersect(textA.getBBox(), pinB.getBBox()),
    textA && textB && boxesIntersect(textA.getBBox(), textB.getBBox()),
  ]

  return intersections.some(Boolean)
}

function boxesIntersect(a: SVGRect, b: SVGRect): boolean {
  return !(
    a.x + a.width < b.x ||
    b.x + b.width < a.x ||
    a.y + a.height < b.y ||
    b.y + b.height < a.y
  )
}

export function hackTextIntoEquallySizedLines(text: string, maxLineLength: number): string[] {
  const words = text.split(' ')
  const lines: string[] = []
  let currentLine = ''

  for (const word of words) {
    if ((currentLine + word).length <= maxLineLength) {
      currentLine += (currentLine ? ' ' : '') + word
    } else {
      if (currentLine) lines.push(currentLine)
      currentLine = word
    }
  }

  if (currentLine) lines.push(currentLine)

  return lines
}